import { useState, useContext, useEffect, useCallback } from "react";
import { loaderContext } from "../contexts/LoaderProvider";
import { profileDetails } from "../services/settingsService";
import { dataContext } from "../contexts/DataProvider";
import { errorContext } from "../contexts/ErrorProvider";
import ProcessData from "../utils/ProcessData";
import validate from "../validation/validator";
import { employeeProfileSchema } from "../validation/schema";
import { editEmployeeProfile } from "../services/settingsService";

const ProfileDetails = () => {
  const [data, setData] = useContext(dataContext);
  const [errors, setErrors] = useContext(errorContext);
  const [alertMessage, setAlertMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const { setIsLoading } = useContext(loaderContext);

  const fetchProfileDetails = useCallback(async () => {
    const response = await profileDetails();
    if (response.data.code === 1) {
      setData(response?.data?.data);
    }
    // eslint-disable-next-line
  }, []);
  const update = useCallback(async () => {
    const validation = validate(data, setErrors, employeeProfileSchema());
    if (validation === true) {
      setIsLoading(true);
      const response = await editEmployeeProfile(data);
      if (response.data.code === 1) {
        setSuccessMessage(response.data.message);
        setData({});
        setErrors({});
        fetchProfileDetails();
      } else {
        setAlertMessage(response.data.message);
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line
  }, [data, errors]);
  useEffect(() => {
    fetchProfileDetails();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    setAlertMessage(null);
    setTimeout(() => {
      setSuccessMessage(null);
    }, 1000);
    // eslint-disable-next-line
  }, [data]);

  return (
    <div className="col-md-12">
      <div className="card custom-card">
        <div className="card-header justify-content-between">
          <div className="card-title">
            <div className="d-flex justify-content-between align-items-center px-3 gap-2">
              <span className="d-block fw-medium fs-15">Profile Details</span>
            </div>
          </div>
        </div>
        <div className="card-body">
          {alertMessage && (
            <div className="alert alert-solid-danger alert-dismissible fade show">
              {alertMessage ?? ""}
              <button
                onClick={() => setAlertMessage(null)}
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <i className="bi bi-x"></i>
              </button>
            </div>
          )}
          {successMessage && (
            <div className="alert alert-solid-success alert-dismissible fade show">
              {successMessage ?? ""}
              <button
                onClick={() => setSuccessMessage(null)}
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <i className="bi bi-x"></i>
              </button>
            </div>
          )}
          <div className="row">
            <div className="col-md-6">
              <label className="mb-2">Name</label>
              <input
                type="text"
                className="form-control form-control-md"
                placeholder="Enter full name"
                value={data?.name ?? ""}
                onChange={(e) => {
                  ProcessData(
                    data,
                    setData,
                    e,
                    "string",
                    "name",
                    errors,
                    setErrors
                  );
                }}
              />
              <small className="text-danger">{errors?.name ?? ""}</small>
            </div>
            <div className="col-md-6">
              <label className="mb-2">Email</label>
              <input
                type="text"
                className="form-control form-control-md"
                placeholder="Enter email address"
                value={data?.email ?? ""}
                onChange={(e) => {
                  ProcessData(
                    data,
                    setData,
                    e,
                    "string",
                    "email",
                    errors,
                    setErrors
                  );
                }}
              />
              <small className="text-danger">{errors?.email ?? ""}</small>
            </div>
          </div>
        </div>
        <div className="card-footer text-end">
          <button onClick={update} className="btn btn-primary btn-md me-2">
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
